module.exports = __webpack_public_path__ + "img/version1-and-version2.8b5e9933.png";